// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aibanner-clipper {
  position: absolute;
  top: 0;
  width: 100%;
  height: 30px;
  overflow: visible;
  pointer-events: none;
  z-index: 1101;
  cursor: pointer;
  font-family: 'Roboto';
  line-height: 30px;
}

.aibanner-label:hover {
  opacity: 1;
}

.aibanner-label {
  right: -70px;
  top: 40px;
  height: 32px;
  font-size: 20px;
  width: 300px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(45deg);
  transform-origin: center center;
  text-align: center;
  font-weight: bold;
  color: #484848;
  background: rgba(94, 255, 0, 0.5);
  border: 1px solid rgb(86, 128, 23);
  z-index: 11;
  pointer-events: auto;
  opacity: 0.5;
}

.aibanner-label-minimal,
.aibanner-label-small {
  right: -100px;
  top: 30px;
  height: 20px;
  font-size: 15px;
  width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/AIBanner.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;AACd","sourcesContent":[".aibanner-clipper {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 30px;\n  overflow: visible;\n  pointer-events: none;\n  z-index: 1101;\n  cursor: pointer;\n  font-family: 'Roboto';\n  line-height: 30px;\n}\n\n.aibanner-label:hover {\n  opacity: 1;\n}\n\n.aibanner-label {\n  right: -70px;\n  top: 40px;\n  height: 32px;\n  font-size: 20px;\n  width: 300px;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: rotate(45deg);\n  transform-origin: center center;\n  text-align: center;\n  font-weight: bold;\n  color: #484848;\n  background: rgba(94, 255, 0, 0.5);\n  border: 1px solid rgb(86, 128, 23);\n  z-index: 11;\n  pointer-events: auto;\n  opacity: 0.5;\n}\n\n.aibanner-label-minimal,\n.aibanner-label-small {\n  right: -100px;\n  top: 30px;\n  height: 20px;\n  font-size: 15px;\n  width: 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
